import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
import { SIZE_OPTIONS, TYPE_OPTIONS, TOKENS } from "./consts";
import FormFeedback from "../FormFeedback";
import DefaultFormLabel from "../FormLabel";
import { StyledServiceLogo } from "../ServiceLogo";
import { rtlSpacing } from "../utils/rtl";
import InputTags from "./InputTags";
import getSpacingToken from "../common/getSpacingToken";
import getFieldDataState from "../common/getFieldDataState";
import { StyledButtonLink } from "../ButtonLink/index";
import randomID from "../utils/randomID";

var getToken = function getToken(name) {
  return function (_ref3) {
    var _TOKENS$heightInput, _TOKENS$fontSizeInput, _TOKENS$iconSize, _tokens;

    var theme = _ref3.theme,
        size = _ref3.size;
    var tokens = (_tokens = {}, _defineProperty(_tokens, TOKENS.heightInput, (_TOKENS$heightInput = {}, _defineProperty(_TOKENS$heightInput, SIZE_OPTIONS.SMALL, theme.orbit.heightInputSmall), _defineProperty(_TOKENS$heightInput, SIZE_OPTIONS.NORMAL, theme.orbit.heightInputNormal), _TOKENS$heightInput)), _defineProperty(_tokens, TOKENS.fontSizeInput, (_TOKENS$fontSizeInput = {}, _defineProperty(_TOKENS$fontSizeInput, SIZE_OPTIONS.SMALL, theme.orbit.fontSizeInputSmall), _defineProperty(_TOKENS$fontSizeInput, SIZE_OPTIONS.NORMAL, theme.orbit.fontSizeInputNormal), _TOKENS$fontSizeInput)), _defineProperty(_tokens, TOKENS.iconSize, (_TOKENS$iconSize = {}, _defineProperty(_TOKENS$iconSize, SIZE_OPTIONS.SMALL, theme.orbit.widthIconSmall), _defineProperty(_TOKENS$iconSize, SIZE_OPTIONS.NORMAL, theme.orbit.widthIconMedium), _TOKENS$iconSize)), _tokens);
    return tokens[name][size];
  };
};

var getPadding = function getPadding() {
  return function (_ref4) {
    var _tokens2;

    var theme = _ref4.theme,
        size = _ref4.size;
    var tokens = (_tokens2 = {}, _defineProperty(_tokens2, SIZE_OPTIONS.SMALL, theme.orbit.paddingInputSmall), _defineProperty(_tokens2, SIZE_OPTIONS.NORMAL, theme.orbit.paddingInputNormal), _tokens2);
    return rtlSpacing(tokens[size]);
  };
};

var getDOMType = function getDOMType(type) {
  if (type === TYPE_OPTIONS.PASSPORTID) {
    return TYPE_OPTIONS.TEXT;
  }

  return type;
};

var Field = styled(function (_ref) {
  var Component = _ref.component,
      className = _ref.className,
      children = _ref.children,
      spaceAfter = _ref.spaceAfter,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["component", "className", "children", "spaceAfter", "theme"]);

  return React.createElement(Component, _extends({
    className: className
  }, props), children);
}).withConfig({
  displayName: "InputField__Field",
  componentId: "sc-4opay-0"
})(["font-family:", ";position:relative;display:block;z-index:2;flex:1 1 100%;width:100%;margin-bottom:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.fontFamily;
}, getSpacingToken);
Field.defaultProps = {
  theme: defaultTheme
};
export var FakeInput = styled(function (_ref6) {
  var children = _ref6.children,
      className = _ref6.className;
  return React.createElement("div", {
    className: className
  }, children);
}).withConfig({
  displayName: "InputField__FakeInput",
  componentId: "sc-4opay-1"
})(["width:100%;position:absolute;z-index:1;top:0;left:0;box-sizing:border-box;height:", ";border-radius:", ";box-shadow:inset 0 0 0 ", ";background-color:", ";font-size:", ";transition:all ", " ease-in-out;"], getToken(TOKENS.heightInput), function (_ref7) {
  var theme = _ref7.theme;
  return theme.orbit.borderRadiusNormal;
}, function (_ref8) {
  var theme = _ref8.theme,
      error = _ref8.error;
  return "".concat(theme.orbit.borderWidthInput, " ").concat(error ? theme.orbit.borderColorInputError : theme.orbit.borderColorInput);
}, function (_ref9) {
  var disabled = _ref9.disabled,
      theme = _ref9.theme;
  return disabled ? theme.orbit.backgroundInputDisabled : theme.orbit.backgroundInput;
}, getToken(TOKENS.fontSizeInput), function (_ref10) {
  var theme = _ref10.theme;
  return theme.orbit.durationFast;
});
FakeInput.defaultProps = {
  theme: defaultTheme
};
export var InputContainer = styled(function (_ref11) {
  var children = _ref11.children,
      className = _ref11.className;
  return React.createElement("div", {
    className: className
  }, children);
}).withConfig({
  displayName: "InputField__InputContainer",
  componentId: "sc-4opay-2"
})(["display:flex;position:relative;flex-direction:row;align-items:center;justify-content:space-between;box-sizing:border-box;height:", ";border-radius:", ";color:", ";font-size:", ";cursor:", ";&:hover > ", "{", ";}", ":active{box-shadow:none;}"], getToken(TOKENS.heightInput), function (_ref12) {
  var theme = _ref12.theme;
  return theme.orbit.borderRadiusNormal;
}, function (_ref13) {
  var disabled = _ref13.disabled,
      theme = _ref13.theme;
  return disabled ? theme.orbit.colorTextInputDisabled : theme.orbit.colorTextInput;
}, getToken(TOKENS.fontSizeInput), function (_ref14) {
  var disabled = _ref14.disabled;
  return disabled ? "not-allowed" : "text";
}, FakeInput, function (_ref15) {
  var disabled = _ref15.disabled,
      theme = _ref15.theme,
      error = _ref15.error;
  return !disabled && "box-shadow: inset 0 0 0 ".concat(theme.orbit.borderWidthInput, " ").concat(error ? theme.orbit.borderColorInputErrorHover : theme.orbit.borderColorInputHover);
}, StyledButtonLink);
InputContainer.defaultProps = {
  theme: defaultTheme
};
var StyledInlineLabel = styled.div.withConfig({
  displayName: "InputField__StyledInlineLabel",
  componentId: "sc-4opay-3"
})(["height:100%;display:flex;align-items:center;pointer-events:none;justify-content:center;padding:", ";", "{margin-bottom:0;font-size:", ";line-height:normal;z-index:3;white-space:nowrap;}"], function (_ref16) {
  var theme = _ref16.theme;
  return rtlSpacing("0 0 0 ".concat(theme.orbit.spaceSmall));
}, DefaultFormLabel, getToken(TOKENS.fontSizeInput));
StyledInlineLabel.defaultProps = {
  theme: defaultTheme
};
export var Prefix = styled(function (_ref17) {
  var children = _ref17.children,
      className = _ref17.className;
  return React.createElement("div", {
    className: className
  }, children);
}).withConfig({
  displayName: "InputField__Prefix",
  componentId: "sc-4opay-4"
})(["height:100%;color:", ";display:flex;align-items:center;pointer-events:none;justify-content:center;padding:", ";z-index:3;& > svg{width:", ";height:", ";color:", ";}"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.orbit.colorTextInputPrefix;
}, function (_ref19) {
  var theme = _ref19.theme;
  return rtlSpacing("0 0 0 ".concat(theme.orbit.spaceSmall));
}, getToken(TOKENS.iconSize), getToken(TOKENS.iconSize), function (_ref20) {
  var theme = _ref20.theme;
  return theme.orbit.colorIconInput;
});
Prefix.defaultProps = {
  theme: defaultTheme
};
var Suffix = styled(function (_ref21) {
  var children = _ref21.children,
      className = _ref21.className;
  return React.createElement("div", {
    className: className
  }, children);
}).withConfig({
  displayName: "InputField__Suffix",
  componentId: "sc-4opay-5"
})(["height:", ";color:", ";display:flex;flex-shrink:0;align-items:center;justify-content:center;pointer-events:", ";z-index:3;& svg{color:", ";}", "{height:16px;padding:", ";}"], getToken(TOKENS.heightInput), function (_ref22) {
  var theme = _ref22.theme;
  return theme.orbit.colorTextInputPrefix;
}, function (_ref23) {
  var disabled = _ref23.disabled;
  return disabled && "none";
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.orbit.colorIconSecondary;
}, StyledServiceLogo, function (_ref25) {
  var theme = _ref25.theme;
  return rtlSpacing("0 ".concat(theme.orbit.spaceSmall, " 0 0"));
});
Suffix.defaultProps = {
  theme: defaultTheme
};
export var Input = styled( // $FlowExpected
React.forwardRef(function (_ref2, ref) {
  var type = _ref2.type,
      size = _ref2.size,
      theme = _ref2.theme,
      error = _ref2.error,
      help = _ref2.help,
      inlineLabel = _ref2.inlineLabel,
      props = _objectWithoutProperties(_ref2, ["type", "size", "theme", "error", "help", "inlineLabel"]);

  return React.createElement("input", _extends({
    type: getDOMType(type)
  }, props, {
    ref: ref
  }));
})).withConfig({
  displayName: "InputField__Input",
  componentId: "sc-4opay-6"
})(["appearance:none;-webkit-text-fill-color:", ";font-family:", ";border:none;padding:", ";font-size:inherit;font-weight:", ";color:inherit;background-color:transparent;cursor:inherit;flex:1 1 20%;width:100%;height:100%;box-sizing:border-box;border-radius:", ";z-index:2;min-width:0;font-variant-numeric:", ";letter-spacing:", ";&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}&[data-com-onepassword-filled]{background-color:inherit !important;}&:focus{outline:none;& ~ ", "{box-shadow:inset 0 0 0 ", ";}}&::placeholder{color:", ";opacity:1;}&:-ms-input-placeholder{color:", ";}&::-ms-input-placeholder{color:", ";}&::-ms-clear,&::-ms-reveal{display:none;}"], function (_ref26) {
  var disabled = _ref26.disabled;
  return disabled && "inherit";
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.orbit.fontFamily;
}, getPadding(), function (_ref28) {
  var inlineLabel = _ref28.inlineLabel,
      theme = _ref28.theme;
  return inlineLabel ? theme.orbit.fontWeightMedium : theme.orbit.fontWeightNormal;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.orbit.borderRadiusNormal;
}, function (_ref30) {
  var type = _ref30.type;
  return type === TYPE_OPTIONS.PASSPORTID && "tabular-nums";
}, function (_ref31) {
  var type = _ref31.type;
  return type === TYPE_OPTIONS.PASSPORTID && "2px";
}, FakeInput, function (_ref32) {
  var theme = _ref32.theme;
  return "".concat(theme.orbit.borderWidthInputFocus, " ").concat(theme.orbit.borderColorInputFocus);
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.orbit.colorPlaceholderInput;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.orbit.colorPlaceholderInput;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.orbit.colorPlaceholderInput;
});
Input.defaultProps = {
  theme: defaultTheme
};

var FormLabel = function FormLabel(_ref36) {
  var label = _ref36.label,
      isFilled = _ref36.isFilled,
      required = _ref36.required;
  return React.createElement(DefaultFormLabel, {
    filled: isFilled,
    required: required
  }, label);
}; // $FlowExpected


var InputField = React.forwardRef(function (props, ref) {
  var disabled = props.disabled,
      _props$size = props.size,
      size = _props$size === void 0 ? SIZE_OPTIONS.NORMAL : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? TYPE_OPTIONS.TEXT : _props$type,
      label = props.label,
      inlineLabel = props.inlineLabel,
      dataTest = props.dataTest,
      required = props.required,
      error = props.error,
      name = props.name,
      prefix = props.prefix,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onKeyUp = props.onKeyUp,
      onKeyDown = props.onKeyDown,
      placeholder = props.placeholder,
      minValue = props.minValue,
      maxValue = props.maxValue,
      minLength = props.minLength,
      maxLength = props.maxLength,
      suffix = props.suffix,
      help = props.help,
      value = props.value,
      tags = props.tags,
      tabIndex = props.tabIndex,
      readOnly = props.readOnly,
      autoComplete = props.autoComplete,
      spaceAfter = props.spaceAfter,
      id = props.id,
      inputMode = props.inputMode;
  var forID = id || (label ? React.useMemo(function () {
    return randomID("inputFieldID");
  }, []) : undefined);
  return React.createElement(Field, {
    component: label ? "label" : "div",
    spaceAfter: spaceAfter,
    htmlFor: label ? forID : undefined
  }, label && !inlineLabel && React.createElement(FormLabel, {
    label: label,
    isFilled: !!value,
    required: required
  }), React.createElement(InputContainer, {
    size: size,
    disabled: disabled,
    error: error
  }, prefix && React.createElement(Prefix, {
    size: size
  }, prefix), label && inlineLabel && React.createElement(StyledInlineLabel, {
    size: size
  }, React.createElement(FormLabel, {
    label: label,
    isFilled: !!value,
    required: required
  })), tags && React.createElement(InputTags, null, tags), React.createElement(Input, {
    "data-test": dataTest,
    "data-state": getFieldDataState(!!error),
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    name: name,
    type: type,
    value: value,
    placeholder: placeholder,
    disabled: disabled,
    min: minValue,
    max: maxValue,
    minLength: minLength,
    maxLength: maxLength,
    size: size,
    error: error,
    ref: ref,
    tabIndex: tabIndex,
    inlineLabel: inlineLabel,
    readOnly: readOnly,
    autoComplete: autoComplete,
    id: forID,
    inputMode: inputMode
  }), suffix && React.createElement(Suffix, {
    size: size
  }, suffix), React.createElement(FakeInput, {
    size: size,
    disabled: disabled,
    error: error
  })), help && !error && React.createElement(FormFeedback, {
    type: "help"
  }, help), error && React.createElement(FormFeedback, {
    type: "error"
  }, error));
});
InputField.displayName = "InputField";
export default InputField;